import "./styles.css";
import React, {useEffect, useState} from "react";
import {timePicker} from "analogue-time-picker";
import {Typography} from "@material-tailwind/react";

export function FromToTimeClock({
                                    from_label,
                                    to_label,
                                    from_value,
                                    to_value,
                                    onChangeFrom,
                                    onChangeTo,
                                }) {
    const [fromShowTime, setFromShowTime] = useState();
    const [toShowTime, setToShowTime] = useState();
    const [fromMinute, setFromMinute] = useState();
    const [fromHour, setFromHour] = useState();
    const [toMinute, setToMinute] = useState();
    const [toHour, setToHour] = useState();

    useEffect(() => {

        var from_time_picker = timePicker({
            element: document.getElementById("from_clock"),
            mode: 24,
            width: "200px",
            time: {
                hour: from_value.split(':').map(Number)[0] ? from_value.split(':').map(Number)[0] : 1,
                minute: from_value.split(':').map(Number)[1] ? from_value.split(':').map(Number)[1] : 0
            },
        })

        from_time_picker.onTimeChanged((hour, minute) => {
            if (hour) {
                setFromHour(hour)
            } else {
                setFromHour(0)
            }

            if (minute) {
                let new_from_minute = Math.ceil(minute / 5) * 5;
                if (new_from_minute > 59) {
                    new_from_minute = 0;
                }
                setFromMinute(new_from_minute);
            } else {
                setFromMinute(0)
            }
        })

        setFromShowTime(from_time_picker);

        if (from_value !== undefined && from_value.length > 0) {
            const [fromHours, fromMinutes] = from_value.split(':').map(Number);
            setFromHour(fromHours);
            setFromMinute(fromMinutes);
            from_time_picker.setTime(fromHours, fromMinutes);
        }

        var to_time_picker = timePicker({
            element: document.getElementById("to_clock"),
            mode: 24,
            width: "200px",
            time: {
                hour: to_value.split(':').map(Number)[0] ? to_value.split(':').map(Number)[0] : 1,
                minute: to_value.split(':').map(Number)[1] ? to_value.split(':').map(Number)[1] : 0
            },
        })
        to_time_picker.onTimeChanged((hour, minute) => {
            if (hour) {
                setToHour(hour)
            } else {
                setToHour(0)
            }
            if (minute) {
                let new_to_minute = Math.ceil(minute / 5) * 5;
                if (new_to_minute > 59) {
                    new_to_minute = 0;
                }
                setToMinute(new_to_minute);
            } else {
                setToMinute(0)
            }
        })
        setToShowTime(to_time_picker);

        if (to_value !== undefined && to_value.length > 0) {
            const [toHours, toMinutes] = to_value.split(':').map(Number);
            setToHour(toHours);
            setToMinute(toMinutes);
            to_time_picker.setTime(toHours, toMinutes);
        }
    }, []);

    useEffect(() => {
        if (fromHour !== undefined && fromMinute !== undefined) {
            const formattedTime = fromHour.toString().padStart(2, '0') + ":" + fromMinute.toString().padStart(2, '0');
            onChangeFrom(formattedTime)
            fromShowTime.setTime(fromHour, fromMinute);
        }

    }, [fromMinute, fromHour]);

    useEffect(() => {
        if (toHour !== undefined && toMinute !== undefined) {
            const formattedTime = toHour.toString().padStart(2, '0') + ":" + toMinute.toString().padStart(2, '0');
            onChangeTo(formattedTime)
            toShowTime.setTime(toHour, toMinute);
        }

    }, [toMinute, toHour]);

    return (
        <div className="flex flex-col md:flex-row justify-between w-full">

            <div className="flex flex-col" key={"from_value"}>
                <Typography className="flex flex-row mb-4">
                    {from_label}
                </Typography>
                <div className="flex flex-row TimeClock">
                    <div id="from_clock"></div>
                </div>
                {/*<Button className="mt-2" onClick={() => {*/}
                {/*  const object = fromShowTime.getTime();*/}
                {/*  const new_minute = Math.ceil((object.minute / 5)) * 5*/}
                {/*  fromShowTime.setTime(object.hour, new_minute);*/}
                {/*  const new_object = fromShowTime.getTime();*/}
                {/*  setFromMinute(new_object.minute);*/}
                {/*  setFromHour(object.hour);*/}
                {/*}} color="#414141">*/}
                {/*  زمان شروع را ثبت کنید*/}
                {/*</Button>*/}
            </div>

            <div className="flex flex-col" key={"to_value"}>
                <Typography className="flex flex-row mb-4">
                    {to_label}
                </Typography>
                <div className="flex flex-row TimeClock">
                    <div id="to_clock"></div>
                </div>
                {/*<Button className="mt-2" onClick={() => {*/}
                {/*  const object = toShowTime.getTime();*/}
                {/*  const new_minute = Math.ceil((object.minute / 5)) * 5*/}
                {/*  toShowTime.setTime(object.hour, new_minute);*/}
                {/*  const new_object = toShowTime.getTime();*/}
                {/*  setToMinute(new_object.minute);*/}
                {/*  setToHour(object.hour);*/}
                {/*}} color="#414141">*/}
                {/*  زمان پایان را ثبت کنید*/}
                {/*</Button>*/}
            </div>

        </div>
    )
        ;
}
